<div class="grid grid-cols-2 gap-x-10 gap-y-2">
    <div class="grid grid-cols-2 gap-x-5 gap-y-2">
        <b>chæmp-ID</b>
        <span>{{ leavingRequest?.employeeChaempId ?? employee?.chaempId }}</span>

        <b i18n>Employee-no.</b>
        <span>{{ leavingRequest?.employeeNumber ?? employee?.employeeNumber }}</span>

        <b i18n>Alternative Employee-no.</b>
        <span>{{ leavingRequest?.employeeAlternativeNumber ?? employee?.alternativeEmployeeNumber }}</span>

        <b i18n>Date of birth</b>
        <span>{{ leavingRequest?.employeeDateOfBirth ?? employee?.dateOfBirth | date: 'dd.MM.yyyy' }}</span>

        <b i18n>Office</b>
        <span>{{ leavingRequest?.employeeOfficeName ?? employeeOfficeName }}</span>
    </div>
</div>
